module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "toast-container"
    }
  }, [_c('transition-group', {
    attrs: {
      "mode": "out-in",
      "name": "slideRight"
    }
  }, _vm._l((_vm.messages), function(toast, i) {
    return _c('div', {
      key: toast.guid,
      class: [toast.type, 'toast-outer']
    }, [_c('header', [_c('i', {
      class: _vm.headerIcon(toast.type)
    }), _vm._v(" " + _vm._s(toast.type.toUpperCase()) + "\n      ")]), _vm._v(" "), _c('p', {
      domProps: {
        "textContent": _vm._s(toast.message)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "close-toast",
      on: {
        "click": function($event) {
          return _vm.remove(toast.guid)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times fa-2x"
    })])])
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02205b6a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Toast.vue
// module id = 2068
// module chunks = 1